import React from "react";

import CellphoneVeriticalSvg from "../../assets/images/icons/cellphone-vertical.svg";

export const CellphoneVerticalIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={CellphoneVeriticalSvg}
        alt={alt || "Cellphone Vertical"}
    />
);
